import { Query } from '@testing-library/react';
import DataStore from 'src/core/stores/data-store';
import { CommandResult } from 'src/core/stores/types';

export class DataStoreMock<T> extends DataStore<T> {
  constructor(_baseUrl: string) {
    super('', []);
  }

  public simulateLoad(items: T[]) {
    this._state.isBusy.set(true);
    return new Promise((resolve) => {
      setTimeout(() => {
        this._state.set({
          isBusy: false,
          count: items.length,
          items: items,
        });
        resolve(items);
      }, 50);
    });
  }

  public async load(_query: Partial<Query>) {
    this._state.set({ isBusy: false, count: 0, items: [] });
    return true;
  }

  public async delete(id: string, _params?: any) {
    const updatedItems = this._state.items.value.filter((x: any) => x.id !== id);
    this._state.set({
      isBusy: false,
      count: updatedItems.length,
      items: updatedItems,
    });
    return {} as CommandResult<any>;
  }

  public async save(id: string, item: T) {
    const updatedItems = this._state.items.value.map((x: any) => (x.id === id ? item : x));
    this._state.set({
      isBusy: false,
      count: updatedItems.length,
      items: updatedItems,
    });
    return { isSuccess: true, messages: [] };
  }
}

export default DataStoreMock;
